import type { FaireProductEntity } from "../../entity_types/product";

export const p_bb425js7uh: FaireProductEntity = {
  token: "p_bb425js7uh",
  type: "product",
  name: "Natural Workwear Uniform Scrub Set 38750 Pewter",
  brandToken: "b_jk6ud2cvvc",
  brandName: "Eastern Off Price",
  imageUrl:
    "https://cdn.faire.com/fastly/3718cb219aea6ed706cec5be8db8714f49fc036872ab05d6bce307a25fe036f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/793ee595d236a18c4621073b9e06c75326340a09b49d1388f880509db7d35abe.jpeg",
    "https://cdn.faire.com/fastly/b3d6c2aceefe512603d92a629eaedc88e1b454d26d9f7886555b4a9a31ad2828.jpeg",
  ],
  priceDollars: 8,
  description:
    "Natural Workwear scrubs are made of a super soft polyester and cotton blend fabric that is ideal for active nursing, dental and medical professionals. Resists stains of all varieties. After a long shift on your feet, your scrubs will still look as fresh as when you started - without all the wrinkles. V-neck and dolman sleeve giving you a comfortable and roomy fit . Control the fit of your medical scrubs pants with the adjustable drawstring waistband.",
  tags: [],
  msrpDollars: 20.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:29.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
